import { render, staticRenderFns } from "./cusAddressAction.vue?vue&type=template&id=83f810f0&scoped=true"
import script from "./cusAddressAction.vue?vue&type=script&lang=js"
export * from "./cusAddressAction.vue?vue&type=script&lang=js"
import style0 from "./cusAddressAction.vue?vue&type=style&index=0&id=83f810f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f810f0",
  null
  
)

export default component.exports